import React, { useEffect, useState } from "react";
import Header from "./header";
import Footer from "../Fotter";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { FaShoppingCart, FaCreditCard } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { AddToCart } from "../redux/slices/AddTocartSlice";
import { viewCartData } from "../redux/slices/ViewCartSlice";
import endPoint from "../redux/EndPoint/endpoint";

const ResellerProductDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [product, setProduct] = useState(null);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedSize, setSelectedSize] = useState(null);
  const [loader, setLoader] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    localStorage.setItem("role", "reseller");
  }, []);

  useEffect(() => {
    const fetchProduct = async () => {
      setLoader(true);
      try {
        const res = await axios.get(
          `https://www.bharatcod.com/reseller/get-resellerproduct/${id}`,
        );
        const data = res?.data?.data;
        setProduct(data);

        if (data?.images?.length > 0) {
          setSelectedImage(data.images[0]);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoader(false);
      }
    };

    fetchProduct();
  }, [id]);

  // 🔥 Add to cart
  const handleAddToCart = async () => {
    if (product?.size?.length > 0 && !selectedSize) {
      toast.error("Please select size");
      return;
    }

    try {
      const storedUuid = localStorage.getItem("uuid");
      const token = localStorage.getItem("authToken");

      let requestBody = {
        quantity: 1,
        size: selectedSize || "",
        sessionId: storedUuid || "",
      };

      if (product?.productId) {
        requestBody.resellerProductId = product._id;
      } else {
        requestBody.productId = product._id;
      }

      const res = await axios.post(endPoint.ADDTOCART, requestBody, {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      });
      toast.success("Added to cart");
    } catch (error) {
      console.error("Add to cart error:", error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  const handleBuyNow = async () => {
    if (product?.size?.length > 0 && !selectedSize) {
      toast.error("Please select size");
      return;
    }

    try {
      const storedUuid = localStorage.getItem("uuid");
      const token = localStorage.getItem("authToken");

      let requestBody = {
        quantity: 1,
        size: selectedSize || "",
        sessionId: storedUuid || "",
      };

      if (product?.productId) {
        requestBody.resellerProductId = product._id;
      } else {
        requestBody.productId = product._id;
      }

      const res = await axios.post(endPoint.ADDTOCART, requestBody, {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      });
      navigate("/cart");
    } catch (error) {
      console.error("Add to cart error:", error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  const description = product?.description || "";
  const descriptionPoints = description.split(/(?<=[.:])\s+(?=[A-Z])/);

  if (loader) {
    return <div className="p-5 text-center">Loading...</div>;
  }

  return (
    <div className="min-h-screen flex flex-col text-black">
      <div className="flex-grow">
        {product && (
          <div className="w-[90%] mx-auto mt-5 flex flex-col md:flex-row gap-10">
            {/* LEFT IMAGE */}
            <div className="md:w-1/2">
              <Zoom>
                <img
                  src={selectedImage}
                  alt="product"
                  className="w-full h-96 object-contain border p-3 "
                />
              </Zoom>

              <div className="flex gap-3 mt-3 justify-center">
                {product?.images?.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt=""
                    onClick={() => setSelectedImage(img)}
                    className={`w-20 h-20 border cursor-pointer ${selectedImage === img ? "border-blue-500" : ""
                      }`}
                  />
                ))}
              </div>

              {/* BUTTONS */}
              <div className="flex gap-3 mt-5 p-4 justify-center">
                <button
                  onClick={handleAddToCart}
                  className="bg-white border px-4 py-2 rounded flex items-center gap-2"
                >
                  <FaShoppingCart /> Add to Cart
                </button>

                <button
                  onClick={handleBuyNow}
                  className="bg-orange-500 text-white px-4 py-2 rounded flex items-center gap-2"
                >
                  <FaCreditCard /> Buy Now
                </button>
              </div>
            </div>

            {/* RIGHT DETAILS */}
            <div className="md:w-1/2">
              <span className="text-2xl font-bold">{product.title}</span>

              {/* PRICE */}
              <div className="mt-3">
                <span className="text-3xl text-red-600 font-bold">
                  ₹{product.price}
                </span>
              </div>

              {/* CATEGORY (NOT CLICKABLE) */}
              <div className="mt-3">
                <b>Category:</b> {product.category}
              </div>

              {/* BRAND (NOT CLICKABLE) */}
              <div className="mt-2">
                <b>Brand:</b> {product.brand}
              </div>

              {/* SIZE */}
              {product?.size?.length > 0 && (
                <div className="mt-4">
                  <h3 className="font-bold mb-2">Select Size</h3>
                  <div className="flex gap-2 flex-wrap">
                    {product.size.map((size) => (
                      <button
                        key={size}
                        onClick={() => setSelectedSize(size)}
                        className={`px-3 py-1 border rounded ${selectedSize === size ? "bg-blue-500 text-white" : ""
                          }`}
                      >
                        {size}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* SPECIFICATIONS */}
              {product?.specifications?.length > 0 && (
                <div className="mt-4">
                  <h3 className="font-bold">Specifications</h3>
                  <table className="w-full border mt-2">
                    <tbody>
                      {product.specifications.map((spec) => (
                        <tr key={spec._id} className="border">
                          <td className="p-2">{spec.key}</td>
                          <td className="p-2">{spec.values}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* DESCRIPTION */}
              <div className="mt-4">
                <h3 className="font-bold">Description</h3>

                <ul className="list-disc pl-4">
                  {(isExpanded
                    ? descriptionPoints
                    : descriptionPoints.slice(0, 5)
                  ).map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>

                {descriptionPoints.length > 5 && (
                  <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    className="text-blue-500 mt-2"
                  >
                    {isExpanded ? "Less" : "More"}
                  </button>
                )}
              </div>

              {/* STOCK */}
              <div className="mt-4 sm:p-0 p-2">
                <b>Stock:</b> {product.stock}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResellerProductDetails;
